<template>
    <div id="fcsd" class="w1200">
        <div class="title">
            <span>福彩3D-频道</span>
            <div>
                <a target="_blank" href="https://www.cwl.gov.cn/ygkj/kjzb/"><span>福彩3D开奖直播</span></a>
                <span @click="$router.push('/ssddt?type=fcsd')">缩水单大厅</span>
                <span>十大缩水学霸排行</span>
                <a target="_blank" href="http://bbs.36886.net/forum.php?mod=forumdisplay&fid=8"><span>天云专区</span></a>
                <span @click="$router.push('/suoshuiruanjian');$vuex('vuex_menuActiveIndex', 5)">3D缩水软件</span>
            </div>
        </div>
        <div class="one">
            <div class="left">
                <ranking :rankingArr="rankingArr" lotteryType="2" />
            </div>
            <div class="right">
                <div class="left">
                    <forecast lotteryType="2" />
                </div>
                <div class="right">
                    <bingqiku lotteryType="2" />
                </div>
            </div>
        </div>

        <div class="two">
            <div class="left">
                <zhuanqu lotteryType="2" />
            </div>
            <div class="right">
                <fcsdPlsKaijiang lotteryType="2" />
            </div>
        </div>
    </div>
</template>

<script>
import ranking from "./components/ranking.vue";
import forecast from "./components/forecast.vue";
import zhuanqu from "./components/zhuanqu.vue";
import fcsdPlsKaijiang from "./components/kaijiang/fcsd_pls.vue";
import bingqiku from "./components/fcsd_pls_bingqiku.vue";
export default {
    components: {
        ranking,
        forecast,
        zhuanqu,
        fcsdPlsKaijiang,
        bingqiku,
    },
    data () {
        return {
            rankingArr: [
                "800-899注",
                "700-799注",
                "400-599注",
                "200-399注",
                "50-199注",
                "1-49注↓",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';
#fcsd {
    margin-top: 20px;
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $theme_color;
        // background-image: linear-gradient(to right,#8FB3DA,);
        padding: 0px 20px;
        padding-left: 0;
        > span {
            font-weight: bold;
            font-size: 28px;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding: 0 20px;
        }
        > div {
            color: #ffffff;
            font-weight: bold;
            > span,
            a {
                margin: 0 10px;
                display: inline-block;
                cursor: pointer;
                position: relative;
                transition: transform 0.5s linear, font-weight 0.5s linear;
                &:hover {
                    transform: scale(1.2);
                    font-weight: bold;
                    &::after {
                        width: 100%;
                        left: 0%;
                    }
                }
                &:not(:hover) {
                    transform: scale(1);
                    font-weight: inherit;
                    &::after {
                        width: 0%;
                        left: 50%;
                    }
                }
                &::after {
                    content: '';
                    display: block;
                    border-bottom: 3px solid #fff;
                    width: 0%;
                    position: absolute;
                    left: 50%;
                    bottom: -5px;
                    transition: width 0.5s linear, left 0.5s linear;
                }
            }
        }
    }
    .one {
        margin-top: 20px;
        display: flex;
        > div {
            &.left {
                flex: 1;
            }
            &.right {
                flex: 2;
                margin-left: 20px;
                display: flex;
                > div {
                    &.left {
                        flex: 2;
                        border-right: 1px solid rgba(0, 0, 0, 0.07);
                    }
                    &.right {
                        flex: 1.3;
                    }
                }
            }
        }
    }
    .two {
        margin-top: 20px;
        display: flex;
        > div {
            // border: 1px solid red;
            &.left {
                flex: 1.5;
            }
            &.right {
                flex: 1;
            }
        }
    }
}
</style>